import "./BasicInformation.html";
import "./EditEquipmentTypeInformation/EditEquipmentTypeInformationComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import BasicInformationComponentController from "./BasicInformationComponentController";

export default class BasicInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentType: "<",
        };
        this.controller = BasicInformationComponentController;
        this.templateUrl = "/App/Components/EquipmentType/BasicInformation/BasicInformation.html";
    }
}

module("mmManagePortal").component("irEquipmentTypeDashboardBasicInformation", new BasicInformationComponent());
